// @core/api/endpoints/signature/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateParty } from './create_party';
import { CreateSignature } from './create_signature';
import { DeleteParty } from './delete_party';
import { GetParty } from './get_party';
import { GetSignature } from './get_signature';
import { ListParties } from './list_parties';
import { ListPartiesByTarget } from './list_parties_by_target';
import { ListSignaturesByTarget } from './list_signatures_by_target';
import { UpdateParty } from './update_party';

// Re-export individual endpoints
export {
  CreateParty,
  CreateSignature,
  DeleteParty,
  GetParty,
  GetSignature,
  ListParties,
  ListPartiesByTarget,
  ListSignaturesByTarget,
  UpdateParty,
};

// Namespace export for convenient usage
export const signatureApi = {
  CreateParty,
  CreateSignature,
  DeleteParty,
  GetParty,
  GetSignature,
  ListParties,
  ListPartiesByTarget,
  ListSignaturesByTarget,
  UpdateParty,
};
